import { Component } from "react";
import Bugsnag from "@bugsnag/js";
import { pageLifecycle } from "@/observability/faro";

import Loader from "../shared/Loader";
import { Button } from "../shared/Button";

export default function (importComponent) {
  return class AsyncClassWrapper extends Component {
    state = {
      component: null,
      loadingChunkError: false
    };

    componentDidMount() {
      pageLifecycle.signal(this, "loading");
      importComponent()
        .then(cmp => {
          this.setState({ component: cmp.default }, () => pageLifecycle.signal(this));
        })
        .catch(error => {
          if (error) {
            this.setState({ loadingChunkError: true }, () => pageLifecycle.signal(this));
            if (Bugsnag.isStarted()) {
              Bugsnag.notify(error, event => event.addMetadata("ui", { source: "chunk-load" }));
            }
          }
        });
    }

    refreshPage = () => {
      window.location.reload();
    };

    componentWillUnmount() {
      pageLifecycle.signal(this);
    }

    render() {
      const C = this.state.component;

      if (!C && this.state.loadingChunkError) {
        return (
          <div className="flex-1 min-h-0 flex flex-col overflow-auto">
            <div className="flex-1 min-h-0 flex flex-col justify-center items-center">
              <div className="flex flex-col w-1/2">
                <span className="icon u-errorWarningIcon mb-10 text-center self-center"></span>
                <p className="text-center items-center text-[26px] font-semibold text-neutral-700">
                  Oops, something went wrong
                </p>
                <p className=" text-center mt-5 font-medium text-gray-410 text-sm leading-[1.4]">
                  {" "}
                  We’ve notified our team of the error that occurred and will be working
                  to resolve the issue. We apologize for any inconvenience this may have
                  caused.{" "}
                </p>
                <div className="flex items-center self-center mt-5">
                  <Button
                    kind="secondary-gray"
                    className="mr-3"
                    onClick={this.refreshPage}
                  >
                    {" "}
                    Reload{" "}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        );
      }
      if (!C) {
        return (
          <div className="flex flex-1 min-h-0 justify-center items-center px-5 xl:px-[30px]">
            <Loader size="70" />
          </div>
        );
      }

      return <C {...this.props} />;
    }
  };
}
